import { PrivateDocFields } from '../types';

export const getPrivateDocSections = (items: PrivateDocFields) => {
  const general: PrivateDocFields = [];
  const details: PrivateDocFields = [];
  const languages: string[] = [];
  const signatories: string[] = [];
  const scanPaths: string[] = [];

  for (let i = 0; i < items.length; i++) {
    const { formKey, value } = items[i];
    let _value: string[] = [];

    if (['languages', 'signatories', 'attachments'].includes(formKey) && value !== undefined) {
      _value = Array.isArray(value) ? value : [value];
    }

    if (formKey === 'languages') {
      languages.push(..._value);
    } else if (formKey === 'signatories') {
      signatories.push(..._value);
    } else if (formKey === 'attachments') {
      scanPaths.push(..._value);
    } else if (i < 2) {
      general.push(items[i]);
    } else {
      details.push(items[i]);
    }
  }

  return { general, details, languages, signatories, scanPaths };
};
